
import { Calendar, Clock, MessageSquare, Video, Link } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Interview } from "@/types/interview";

interface InterviewDetailsProps {
  interview: Interview;
}

export const InterviewDetails = ({ interview }: InterviewDetailsProps) => {
  return (
    <>
      <div className="flex items-center gap-6 text-gray-600 flex-wrap">
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4 text-sky-500" />
          <span>{interview.date}</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-sky-500" />
          <span>{interview.time}</span>
        </div>
        <div className="flex items-center gap-2">
          {interview.type === "video" ? (
            <Video className="w-4 h-4 text-sky-500" />
          ) : (
            <MessageSquare className="w-4 h-4 text-sky-500" />
          )}
          <span>{interview.type.charAt(0).toUpperCase() + interview.type.slice(1)} Call</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-sky-500" />
          <span>{interview.duration}</span>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-gray-700 font-medium">
          Project: {interview.project}
        </p>
        {interview.notes && (
          <p className="text-gray-600 text-sm">
            Notes: {interview.notes}
          </p>
        )}
      </div>
    </>
  );
};
